import { Link } from "react-router-dom";
import { formatKickoff } from "../lib/format";
import { Countdown } from "./Countdown";

export const GameCard = ({ game }) => {
  const k = formatKickoff(game.kickoff);
  const isFinal = game.status === "final";
  const isLive = game.status === "live";
  const homeWin = isFinal && game.homeScore > game.awayScore;
  const awayWin = isFinal && game.awayScore > game.homeScore;

  const Row = ({ team, logo, name, score, win }) => (
    <div className="flex items-center justify-between gap-3 py-2">
      <Link
        to={`/team/${team}`}
        data-testid={`gamecard-team-${team}`}
        className="flex items-center gap-3 min-w-0 hover:text-primary transition-colors duration-150"
      >
        <img src={logo} alt={team} className="w-8 h-8 object-contain shrink-0" />
        <span className={`font-semibold truncate ${win ? "text-foreground" : ""}`}>{name}</span>
      </Link>
      {game.status !== "scheduled" && (
        <span
          className={`font-display text-3xl leading-none tabular-nums shrink-0 ${
            win ? "text-primary" : "text-muted-foreground"
          }`}
        >
          {score}
        </span>
      )}
    </div>
  );

  return (
    <div
      data-testid={`game-card-${game.id}`}
      className="border border-border bg-card hover:border-primary/60 transition-colors duration-150"
    >
      <div className="flex items-center justify-between px-4 py-2 border-b border-border bg-secondary/60">
        <span className="text-[11px] font-semibold uppercase tracking-wider text-muted-foreground">
          {game.broadcast}
        </span>
        {isLive ? (
          <span className="flex items-center gap-1.5 text-accent text-[11px] font-bold uppercase">
            <span className="w-2 h-2 rounded-full bg-accent live-dot" /> Live · {game.quarter}
          </span>
        ) : isFinal ? (
          <span className="text-[11px] font-bold uppercase text-muted-foreground">Final</span>
        ) : (
          <span className="text-[11px] font-semibold text-primary">{k.time}</span>
        )}
      </div>
      <div className="px-4 py-2 divide-y divide-border/50">
        <Row team={game.awayTeam} logo={game.awayLogo} name={game.awayName} score={game.awayScore} win={awayWin} />
        <Row team={game.homeTeam} logo={game.homeLogo} name={game.homeName} score={game.homeScore} win={homeWin} />
      </div>
      {game.status === "scheduled" && <Countdown kickoff={game.kickoff} />}
      <div className="px-4 py-2 border-t border-border flex items-center justify-between text-[11px] text-muted-foreground">
        <span>{k.date}</span>
        <span className="flex items-center gap-2">
          <span>{game.stadium}</span>
          <span className="px-1.5 py-0.5 bg-secondary border border-border text-foreground font-semibold">
            {game.network}
          </span>
        </span>
      </div>
    </div>
  );
};
